<h2 i18n>Projected Underground Plumbing</h2>

<mat-card>
  <table class="table-underground">
    <tr>
      <td i18n>Installation of subducts in the narrow trench technique</td>
    </tr>
    <tr>
      <td i18n>Installation of side duct on pole for installation of optical cables</td>
    </tr>
    <tr>
      <td i18n>Underground box construction</td>
    </tr>
    <tr>
      <td i18n>Installation of subducts crossing bridges and viaducts</td>
    </tr>
    <tr>
      <td i18n>Installation of subducts by a non-destructive method</td>
    </tr>
  </table>
</mat-card>


<h2 class="subtopic" i18n>Projected Underground Channeling Elements</h2>

<mat-card>
  <table class="table-underground">
    <tr>
      <th i18n>Connection</th>
      <th i18n>Elements</th>
    </tr>
    <mat-divider></mat-divider>
    <tr>
      <td i18n>Termination closure - Underground box</td>
      <td i18n>Installation of side duct on pole for installation of optical cables</td>
    </tr>
    <tr>
      <td i18n>Properties - Termination closure</td>
      <td i18n>Pole</td>
    </tr>
    <tr>
      <td i18n>Underground box - Underground box</td>
      <td i18n>Installation of subducts in the narrow trench technique</td>
    </tr>
    <tr>
      <td i18n>Side duct on pole - Underground box</td>
      <td i18n>Installation of subducts in the narrow trench technique</td>
    </tr>
    <tr>
      <td i18n>Street crossing</td>
      <td i18n>Installation of subducts by a non-destructive method</td>
    </tr>
    <tr>
      <td i18n>Crossing bridges and viaducts</td>
      <td i18n>Installation of subducts</td>
    </tr>

  </table>
</mat-card>


<h2 class="subtopic" i18n>Projected Accessories</h2>


<div fxLayout="row wrap">
  <div fxFlex class="container-underground">
    <mat-card>
      <table class="table-underground">
        <tr>
          <td i18n>Anchoring set with aluminum alloy optical cables from 6.8 mm to 7.4 mm</td>
        </tr>
        <tr>
          <td i18n>Anchoring set with aluminum alloy optical cables from 8.0 mm to 8.6 mm</td>
        </tr>
        <tr>
          <td i18n>Anchoring set with aluminum alloy optical cables from 9.6 mm to 10.4 mm</td>
        </tr>
        <tr>
          <td i18n>Anchoring set with aluminum alloy optical cables from 11.2 mm to 12.2 mm</td>
        </tr>
        <tr>
          <td i18n>Anchoring set with aluminum alloy optical cables from 12.8 mm to 14.2 mm</td>
        </tr>
        <tr>
          <td i18n>Anchoring set with aluminum alloy optical cables from 16.0 mm to 17.0 mm</td>
        </tr>
        <tr>
          <td i18n>Anchoring kit with dieletric handle</td>
        </tr>
        <tr>
          <td i18n>Adjustable clamp for pole</td>
        </tr>
        <tr>
          <td i18n>Optiloop technical reserve support</td>
        </tr>
        <tr>
          <td i18n>Dieletric wire rope</td>
        </tr>
      </table>
    </mat-card>
  </div>

  <div fxFlex class="container-underground">
    <mat-card>
      <table class="table-underground">
        <tr>
          <th i18n>Reference</th>
          <th i18n>Elements</th>
        </tr>
        <mat-divider></mat-divider>
        <tr>
          <td i18n>Termination optical closure fixation</td>
          <td i18n>Pole</td>
        </tr>
        <tr>
          <td i18n>Optical closure fixation</td>
          <td i18n>Optiloop techincal reserve support</td>
        </tr>
        <tr>
          <td i18n>Aerial cables fixation</td>
          <td i18n>Anchoring set with aluminum alloy</td>
        </tr>
        <tr>
          <td i18n>Technical reserve of optical cables</td>
          <td i18n>Optiloop technical reserve support</td>
        </tr>
        <tr>
          <td i18n>Dieletric strand fixation</td>
          <td i18n>Anchoring kit with dieletric handle</td>
        </tr>
        <tr>
          <td i18n>Anchoring set fixing</td>
          <td i18n>Adjustable clamp for pole</td>
        </tr>
        <tr>
          <td i18n>Aerial crossing</td>
          <td i18n>Dieletric wire rope</td>
        </tr>

      </table>
    </mat-card>
  </div>
</div>
